/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileData/Tag/Payer/Relationships/Content/Relationship/Name"
  
}) {
let dependentPersonToPersonRecordValueData = fromData.useDataFormat({ viewPath,
context: 'dependentPerson',
path: 'to_person_record',
format: fromFormat.personName,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="dependentPerson.to_person_record"
 format="/Data/format.js personName"
 text={dependentPersonToPersonRecordValueData}
 color={dtColorsWhite}
 size="normal"
/>
{children}
</React.Fragment>)
}